import template from './flight-fare.html';
import {outOfPolicyStatusStyle} from '../../../common/enum/out-of-policy-status-style';

const DIRECTIVE_NAME = FlightFare.DIRECTIVE_NAME = 'ktFlightFare';
export default function FlightFare() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightFareController,
        controllerAs: '$ctrl',
        scope: {
            fare: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightFareController(
    userService,
    flightFareService,
    supplierService,
    moment,
    l10nService
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        getOutOfPolicyMessage,
        isBritishAirwaysFlightId,
        moment,
        fareInfo: null,
        getOutOfPolicyStatusStyle,
        l10nService,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        initFareInfo();
        vm.benefits = flightFareService.prepareBenefits(vm.fare.FareBenefits);
    }

    function initFareInfo() {
        flightFareService.getFareType(vm.fare.FareType)
            .then((fareInfo) => Object.assign(vm, {fareInfo}));
    }

    function getOutOfPolicyMessage() {
        const status = vm.fare.OutOfPolicyStatus;
        const messages = vm.fare.OutOfPolicyMessages;
        if (!(status && messages)) {
            return '';
        }
        return messages.join('<br><br>');
    }

    function isBritishAirwaysFlightId() {
        return supplierService.isBritishAirwaysFlightId(vm.recommendation.Supplier);
    }

    function getOutOfPolicyStatusStyle(status) {
        return outOfPolicyStatusStyle(status);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-fare/flight-fare-component.js